import { ICallableRequestBuilder } from "@/api/requestBuilder/types";
import config from "@shared/config/client";
import queryString from "query-string";
import { DynamicCount } from "../types";

export const getLikesFromNftComments =
  (request: ICallableRequestBuilder<DynamicCount>) =>
  async (commentIds: string[]) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/likes/nft/comment/bulk-count`,
      query: {
        ids: commentIds,
      },
    });

    return request.call(url);
  };

const getNftLikesBulkCount =
  (request: ICallableRequestBuilder<number>) => (ids: string[]) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/likes/nft/bulk-count`,
      query: {
        ids,
      },
    });

    return request.call(url);
  };

const getNftLikesCount =
  (request: ICallableRequestBuilder<number>) => (nftId: string) => {
    const url = `${config.apiUrl}/likes/nft/count/${nftId}`;

    return request.call(url);
  };

const requests = {
  getLikesFromNftComments,
  getNftLikesBulkCount,
  getNftLikesCount,
};

export default requests;
